
export default class {
  constructor(restApi, module, relationships, id) {
    this.restApi = restApi;
    this.module = module;
    this.relationships = relationships;
    this.id = id;
  }
  
  loadRelationships() {
    var that = this;
    
    if(this.relationships) {
      return Promise.all(this.relationships.map(function(relationship) {
          return that.restApi.getRelationship(that.id, relationship)
                .then(json => {
                  that[relationship.name] = relationship.moduleClass.createModel(that.restApi, json);
                  return that;
                });
        }))
        .then(arr => { return that; });
    }
    else {
      return Promise.resolve(this);
    }
  }
  
  static createModel(modelClass, restApi, jsonObject, nameMapping) {
    var model = new modelClass(restApi);
    
    nameMapping.forEach(function(namePair) {
      if(jsonObject) {
        model[namePair.modelName] = jsonObject[namePair.apiName];
      }
      else {
        model[namePair.modelName] = namePair.defaultValue;
      }
    });
    
    return model;
  }
  
  static translateModelToApi(modelClass, restApi, model, nameMapping) {
    var apiModel = {};
    
    nameMapping.forEach(function(nameMap) {
      apiModel[nameMap.apiName] = model[nameMap.modelName];
    });
    
    return apiModel;
  }
}



// WEBPACK FOOTER //
// ./src/modules/BaseModel.js